import { render, staticRenderFns } from "./authentice-name.vue?vue&type=template&id=59d92c8c"
import script from "./authentice-name.vue?vue&type=script&lang=js"
export * from "./authentice-name.vue?vue&type=script&lang=js"
import style0 from "./authentice-name.vue?vue&type=style&index=0&id=59d92c8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports